export const OVERBLEED = 200;
export const SCALE = 0.5;
export const BLUR_PX = 80;

export const DEFAULT_COLORS = [
  [50, 120, 200],
  [140, 80, 200],
  [80, 180, 220],
  [160, 160, 180],
];

export const QUAD = new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]);
